// Nuxt/Vite handles the JSON parsing automatically
import type {Product} from '~/types/product'
import rawData from '~/assets/data/products.json';

// 2. Export the typed constant
// This 'as MemorialItem[]' is the "Type Assertion" that tells TS
// to treat the generic JSON as your specific interface
export const AllProducts: Product[] = rawData as Product[];